<template>
    <div class="form-popup">
        <div class="form-popup-backdrop"></div>
        <div class="form-popup-close" @click="close"></div>

        <div class="form-popup-container">
            <div class="m-b-50 text-left">
                <div class="form-popup-heading text-center m-b-30">
                    <h4>{{ $t('cookieConsent.preferences.title') }}</h4>
                    <p>{{ $t('cookieConsent.preferences.description') }}</p>
                </div>

                <div class="preferences">
                    <div v-for="(value, key) in consent">
                        <div class="d-flex">
                            <div class="flex-fill">
                                <label :for="key" class="d-block m-r-20"
                                       :class="{'clickable': ConsentManager().requiredConsentTypes.includes(key) === false}">
                                    <strong>{{ $t(`cookieConsent.type.title.${key}`) }}</strong><br/>
                                    {{ $t(`cookieConsent.type.description.${key}`) }}
                                </label>
                            </div>
                            <div class="flex-shrink-1">
                                <label class="switch">
                                    <input
                                        type="checkbox"
                                        v-model="consent[key]"
                                        true-value="granted"
                                        false-value="denied"
                                        :disabled="ConsentManager().requiredConsentTypes.includes(key)"
                                        :id="key">
                                    <span class="slider"></span>
                                </label>
                            </div>
                        </div>

                        <hr/>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <button type="submit" class="button button--dark" @click="updatePreferences" :disabled="loading"
                        :class="{'button--loading': loading}">{{ $t('cookieConsent.preferences.save') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {ref} from "vue";
import ConsentManager from "./ConsentManager";

export default {
    name: 'ConsentPreferences',
    setup() {
        const loading = ref(false);
        const consent = ref(ConsentManager.getConsentSettings());

        return {
            loading,
            consent,
        };
    },
    methods: {
        ConsentManager() {
            return ConsentManager
        },
        close() {
            this.$emit('updateVisibility', false);
        },
        updatePreferences() {
            this.loading = true;

            let consentPreferences = {};

            for (let key in this.consent) {
                consentPreferences[key] = this.consent[key] === 'granted' ? 'granted' : 'denied';
            }

            ConsentManager.onConsentChange(consentPreferences);

            // Wait for 1.4s to have a better indicator of the changes being saved
            setTimeout(() => {
                this.close();
            }, 1400);
        }
    },
    mounted() {
        // Check if the user has already saved preferences
        if(ConsentManager.hasSavedPreferences() === false) {
            // Default to all consent types being accepted
            for (let key in this.consent) {
                this.consent[key] = 'granted';
            }
        }
    }
}
</script>

<style scoped>
.clickable {
    cursor: pointer;
}
.preferences {
    font-size: 1.6rem;
    line-height: 1.7;
}
</style>
